import React, { useState } from "react";
import { DialogContent, styled, Link } from "@mui/material";
import homeHero from "../../assets/clinic/homeHero.png";
import { STANDALONE_TUTORIAL } from "./clinicSettings/clinicUrls";
import { ClinicDialog } from "./elements/clinicDialog";

//region [[ Styles ]]

const WelcomeDialogView = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: 45,
  fontSize: 16,
  "& img": {
    maxWidth: "100%",
    margin: 30,
  },
  "& label span": {
    fontSize: 13,
  },
});
const WelcomeTitle = styled("h3")({
  fontSize: 25,
  lineHeight: 1.2,
  margin: "0 0 10px 0",
  textAlign: "center",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WelcomeDialogProps {
  username: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const WelcomeDialog = ({ username }: WelcomeDialogProps) => {
  const neverShowVar = "dontShowWelcome" + username;
  const neverShow = localStorage.getItem(neverShowVar) === "true";
  const [showDialog, setShowDialog] = useState<boolean>(!neverShow);

  if (!showDialog) return null;

  const hideDialog = () => {
    localStorage.setItem(neverShowVar, "true");
    setShowDialog(false);
  };

  return (
    <ClinicDialog open={true} onClose={() => hideDialog()} closeButton={true}>
      <WelcomeDialogView>
        <WelcomeTitle>Welcome to Kahun!</WelcomeTitle>
        <div>
          Start by reading{" "}
          <Link href={STANDALONE_TUTORIAL} target="_blank">
            our tutorial
          </Link>
          .
        </div>
        <img src={homeHero} alt="Welcome to Kahun" />
      </WelcomeDialogView>
    </ClinicDialog>
  );
};
